import { SET_FACILITY_SUCCEEDED } from './type'

export const setFacility = (id: number, name: string) => {
  return {
    type: SET_FACILITY_SUCCEEDED,
    id,
    name,
  };
};
